export function getOptions(links) {
  // `value` is the unique `id` (block can repeat across links); `block` is
  // carried for the submit payload (see getCardStageSubmitHandler).
  return links.map(link => ({
    block: link.block,
    label: link.name,
    value: link.id,
  }))
}
